import React from 'react';
import { FDClickableText, FDStack } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

const ManualRolloverSection = () => {
  const { resource, onSubmit } = useMetaLayoutContext();

  // if we dont have webview relationship, then this must be manual flow, just return null
  const isManualFlow = resource.withRelationship(fr.relationships.webview.name, () => false, () => true);
  if (isManualFlow) {
    return null;
  }

  const handlePrimaryActionClick = async () => {
    await onSubmit();
  };

  return (
    <FDStack direction={'column'} alignItems={'center'}>
      <BodyTextMedium color={'textSecondary'} value={<FDClickableText onClick={handlePrimaryActionClick} appearance={'standalone'} label={'Nope, I\'d rather roll over manually.'} />} />
      <BodyTextMedium align={'center'} value={'(This option often takes longer to transfer your funds.)'} />
    </FDStack>
  );
};

ManualRolloverSection.defaultProps = {
};

ManualRolloverSection.propTypes = {
};

export default ManualRolloverSection;
